import { render, staticRenderFns } from "./Pinxpolicy.vue?vue&type=template&id=4deca7f5&scoped=true&"
import script from "./Pinxpolicy.vue?vue&type=script&lang=js&"
export * from "./Pinxpolicy.vue?vue&type=script&lang=js&"
import style0 from "./Pinxpolicy.vue?vue&type=style&index=0&id=4deca7f5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4deca7f5",
  null
  
)

/* custom blocks */
import block0 from "./Pinxpolicy.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports